export default {
  //Prod
  //RutaApi: "https://api.columbiabiotec.com/api",
  RutaApi: "https://qasapi.columbiabiotec.com/api",
  RutaResultados: "/Uploads/pdf/",
  //Dev
  //RutaApi: "http://10.211.55.4/BiotecApi/api", //Debug MacOS
  //RutaResultados: "http://10.211.55.4/BiotecApi/pdf/", //Debug MacOS
  RutaCSVPrePCR: "/Uploads/PrePCR/",
  RutaUploadImagenes: "/Uploads/images/",
  ServicioImpresion: "localhost:9000",
};
